const cancel = 'Zrušit'
const save = 'Uložit'

export default {
  global: {
    generalError: 'Kruciš! Požadavek se nepodařilo zpracovat. Načtěte prosím stránku znova.',
    signature: 'S pozdravem,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Přidejte CV nebo další požadované přílohy',
      placeholderWithDescription: 'Přidejte požadované přílohy',
      remove: 'Odstranit',
      allowedFileTypes: 'Povolené typy souborů',
      errors: {
        size: 'Soubor je příliš velký, maximální velikost souboru je 5MB.',
        empty: 'Soubor neobsahuje žádná data',
        invalidType: fileType => `Je nám líto, soubory ${fileType} nejsou z bezpečnostních důvodů povoleny`,
        typeNotWhitelisted: 'Je nám líto, typ souboru není povolen.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Zásady ochrany osobních údajů',
      termsLinkText: 'Podmínky',
      privacyPolicyText: 'Vážíme si vašeho soukromí. Přečtěte si prosím naše ',
      termsText1: 'Přečtěte si a přijměte ',
      termsText2: 'než nám poskytnete své osobní údaje.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Jestli nechcete, abychom zpracovávali vaše osobní údaje, můžete si zažádat o odstranění ve zprávě na adresu ${mail}.`,
      customSupportPrivacyInfo: link => `Pokud si nepřejete, abychom zpracovávali vaše osobní údaje, můžete požádat o jejich odstranění na adrese ${link}.`,
    },

    buttons: {
      close: 'Zavřít',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Smazat natočené video',
      confirm: 'Zkusit znova',
    },

    confirmButton: {
      wait: count => `Čekejte ${count}`,
      confirm: 'Potvrdit',
    },

    controlStatus: {
      text: {
        empty: 'Vyplňte',
        valid: () => 'Připraveno',
      },
      textarea: {
        empty: 'Vyplňte',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Nastavit',
        valid: () => 'Připraveno',
      },
      file: {
        empty: 'Vybrat',
        valid: () => 'Změnit',
      },
      list: {
        empty: 'Přidat',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Hledat',
        valid: () => 'Připraveno',
      },
    },

    cookieConsentModal: {
      title: 'Naše webové stránky používají soubory cookie',
      body: 'Přijetím všech souborů cookie souhlasíte s tím, že za účelem zlepšení navigace na webu, analýzy využití webu a pomoci v našem marketingovém úsilí budou na vašem zařízení uloženy soubory cookie.',
      learnMoreLinkText: 'Další informace o tom, jak používáme soubory cookie',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Spravovat soubory cookie',
      acceptAll: 'Přijmout všechny soubory cookie',
      manageTitle: 'Spravovat předvolby souhlasu',
      necessaryCookiesTitle: 'Nezbytné soubory cookie',
      necessaryCookiesBody:
        'Tyto soubory cookie jsou pro fungování webových stránek nezbytné a nelze je v našich systémech vypnout.',
      performanceCookiesTitle: 'Výkonnostní soubory cookie',
      performanceCookiesBody:
        'Tyto soubory cookie nám umožňují počítat návštěvy a zdroje návštěvnosti, abychom tak mohli měřit a zlepšovat výkon našich stránek.',
      confirmChoices: 'Potvrdit mé volby',
      marketingCookiesTitle: 'Marketingové soubory cookie',
      marketingCookiesBody:
        'Tyto soubory cookie nám umožňují přizpůsobit reklamu a měřit její výkonnost.',
      functionalCookiesTitle: 'Funkční soubory cookie',
      functionalCookiesBody:
        'Tyto soubory cookie se používají k vylepšení funkčnosti webových stránek. Některé funkce nemusí být bez těchto souborů cookie dostupné. K příkladům využití funkčních cookies patří služby webového chatu a uživatelská nastavení.',
    },

    emailAddresses: {
      remove: 'Odstranit',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Zakázáno',
      content: 'Náš server slušně, ale neochvějně odmítl splnit požadavek vašeho prohlížeče. Pozor, Recright se dá používat vždycky jen s jedním zařízením/prohlížečem zároveň.',
      link: 'Titulní strana',
    },

    error404: {
      heading: 'Hic sunt leones',
      content: 'Ať hledáme, jak hledáme, na vámi vyžádané adrese není žádná webová stránka. Možná jste klikli na odkaz, který vypršel, nebo jste omylem zadali nesprávnou adresu.',
      link: 'Titulní strana',
    },

    error410: {
      heading: 'Zavřená',
      content: 'Pracovní pozici není možné zobrazit, buď proto, že byla zavřena, nebo že skončilo období pro odesílání žádostí.',
      link: 'Titulní strana',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Spouští se...',
      connection_error_hint: 'Nepodařilo se připojit k síti. Zkuste stránku znova načíst.',
      permission_hint: 'Musíte těmto stránkám dovolit používání vaší webkamery a mikrofonu.',
      searching_camera_hint: 'Hledá se webkamera...',
      camera_reserved_hint: 'Vaši webkameru má vyhrazenou jiná aplikace nebo webová stránka. Zavřete prosím tuto aplikaci a znova načtěte stránku.',
      camera_reserved_hint_chrome_extra: 'Vážený uživateli prohlížeče Chrome, musíte Recright dovolit používat webkameru v dialogu pod panelem adresy.',
      no_camera_hint: 'Nepodařilo se najít webkameru.',
      no_mic_hint: 'Nepodařilo se najít mikrofon.',
      uploading_text: 'Nahrává se…',
      rtmpt_in_use: 'Tento krok by nebyl potřeba, kdyby váš správce sítě povolil RTMP. Zeptejte se nás, jak.',
      preview_text: 'Webkamera je v režimu náhledu',
      close_text: 'Zavřít kameru',
      remove_text: 'Smazat natočené video',
      noflash_errortext_install: link => `Vypadá to, že nemáte Adobe Flash Player. K natáčení videí plug-in flashe potřebujete. Stáhněte si flash odtud: ${link}`,
      noflash_errortext_enable: link => `Jestli už flash nainstalovaný máte, ale tuto hlášku vidíte i nadále, podívejte se sem: ${link}`,
      noflash_errortext_differentbrowser: 'Jiná možnost je zkusit to s prohlížečem, který podporuje natáčení videa pomocí HTML5. Doporučujeme Chrome nebo Firefox.',
    },

    footer: {
      terms: 'Podmínky',
      license: 'General Terms of Service',
      privacyPolicy: 'Zásady ochrany soukromí',
      customSupport: link => `Obraťte se na ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Jaké jsou vaše dojmy z pohovoru?',
      howWouldYouRateJobAd: 'Jak byste ohodnotili svou zkušenost s aplikací?',
      yourResponseIsAnonymous: 'Vaše odpověď je anonymní.',
      thankYouFeedback: 'Děkujeme vám za zpětnou vazbu!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Je nám líto, typ souboru není povolen.',
      isRequired: 'Toto pole je povinné.',
      isEmail: value => `${value} není platný email.`,
      isDate: value => `${value} není platné datum.`,
      invalidUrl: 'URL je neplatné.',
      singleHireEndError: 'Jednorázový nábor není možné používat víc než 60 dnů.',
      isNotTooOldForLive: 'Datum je v minulosti.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Jméno',
      city: 'Rodné město',
      email: 'E-mail',
      phone: 'Telefonní číslo',
      applyForPosition: 'Ucházet se o tuto pracovní pozici',
      back: 'Zpět',
      continue: 'Pokračovat',
      submit: 'Odeslat',
      saveForLater: 'Pokračovat později',
      namePlaceholder: 'Zadejte své jméno',
      emailPlaceholder: 'Zadejte svou emailovou adresu',
      phonePlaceholder: 'Zadejte své telefonní číslo',
      cityPlaceholder: 'Zadejte vaše současné město bydliště',
      links: 'Přidejte odkazy, například svůj profil na LinkedInu.',
      legendBasicInfo: 'Základní informace',
      legendLinks: 'Odkazy',
      legendAttachments: 'Přílohy',
      legendAdditionalFields: 'Další informace',
      coverLetter: 'Motivační dopis',
      attachments: 'Přílohy',
      introduction: 'Sem napište svůj krátký úvod',
      thankYou: 'Děkujeme.',
      luck: 'Hodně štěstí!',
      close: 'Zavřít',
      required: 'Položky označené * hvězdičkou jsou povinné.',
    },

    jobAdContainer: {
      endTime: date => (date ? `otevřená do ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Ucházet se o pracovní pozici',
    },

    jobAdRow: {
      responses: 'Žádosti',
      status: {
        open: 'Otevřená',
        filled: 'Obsazená',
        cancelled: 'Zrušená',
        done: 'Hotová',
        close: 'Zavřít',
        draft: 'Zavřená (koncept)',
        hidden: 'Skrytá',
      },
    },

    jobAdQuickInterview: {
      back: 'Zpět',
      submit: 'Odeslat',
      saveForLater: 'Pokračovat později',
      title: 'Rychlý videopohovor',
      description: 'Abychom se s vámi poznali rychleji, rádi bychom, abyste v krátkosti zodpověděli rychlé otázky našeho pohovoru. Projevte svou osobnost a dejte své žádosti o zaměstnání duši.',
      requiredNote: 'Pozor, jde jen o jednu z částí procesu ucházení se o zaměstnání; náborář vaši žádost dostane teprve, až natočíte všechny odpovědi.',
      reminderNote: 'Odpovědi můžete natočit hned, nebo jestli chcete pokračovat později, přijde vám připomenutí emailem.',
    },

    interviewRow: {
      responses: 'Uchazeči',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Zobrazit profil z LinkedInu',
    },

    linkedInButton: {
      error: 'Chyba při načítání z profilu. Zkuste to prosím znovu.',
      buttonText: 'Přihlásit se pomocí LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Svůj profil na LinkedInu můžete použít k předvyplnění formuláře žádosti o zaměstnání',
      linkedInOr: 'nebo',
      error: 'Chyba při načítání z profilu. Zkuste to prosím znovu.',
    },

    linkListInput: {
      addField: 'Přidat',
      removeField: 'Odstranit',
      invalidUrl: 'URL je neplatné.',
    },

    loadingButton: {
      loading: 'Nahrává se...',
      saving: 'Ukládá se...',
      sending: 'Odesílá se...',
    },

    modalApplicationForm: {
      applyForPosition: 'Ucházet se o tuto pracovní pozici',
      continue: 'Pokračovat',
      name: 'Zadejte své jméno',
      email: 'Zadejte svou emailovou adresu',
      phoneNumber: 'Zadejte své telefonní číslo',
      links: 'Můžete vkládat odkazy',
      legendLinks: 'Odkazy',
      legendAttachments: 'Přílohy',
      coverLetter: 'Motivační dopis',
      attachments: 'Přílohy',
      introduction: 'Sem napište svůj úvod',
      thankYou: 'Děkujeme.',
      luck: 'Hodně štěstí!',
      close: 'Zavřít',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Veřejný odkaz ke sdílení',
      info: 'Tady je veřejná adresa pracovního inzerátu, kterou můžete sdílet.\nKdokoli se zájmem o tuto pracovní pozici si inzerát může zobrazit a o pozici se ucházet.\nAž začnou chodit žádosti, budete dostávat obvyklá upozornění.\n\nTady je veřejný odkaz na inzerát pracovní pozice:',
    },

    modalVideoAdd: {
      title: 'Přidat nové video',
      chooseTitle: 'Přidat nové video',
      titlePlaceholder: 'Sem zadejte název videa',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Nahrát nové video',
      info: 'Maximální povolená velikost videa je 500 MB. Doporučujeme videa před nahráváním zkomprimovat, aby nahrávání a konverze zabraly méně času.',
    },

    modalCandidateInfo: [
      {
        headline: 'Natočte svou videoodpověď kolikrát budete chtít. ',
        content: 'Videa se uloží hned po natočení, vy se k videopohovoru budete moct vrátit přes odkaz, který jste dostali do emailu.',
        mobileContent: 'kolikrát budete chtít. Přidejte toto video k pohovoru. Uvidíte, jak se video nahrává a ukládá v pohovoru. K videu se můžete vrátit přes odkaz, který jste dostali do emailu. <br><br><strong>Jestli vaše obrazovka zůstane černá a jestli používáte mobilní zařízení Apple, pokyny k vyřešení problému najdete <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">zde</a>.</strong>',
      },
      {
        headline: 'Po natočení ',
        content: 'se ujistěte, že se video v pořádku přehrává a že je slyšet váš hlas. Až zmáčknete tlačítko „Odeslat“, vaše odpověď bude zamčena a už ji nebudete moct upravovat.',
      },
      {
        headline: 'Až budete s pohovorem hotoví, ',
        content: 'zmáčkněte tlačítko „Odeslat odpovědi a dokončit pohovor“. Potom už se k videopohovoru nebudete moct vrátit. Jestli stránku chcete zavřít, ale později v pohovoru pokračovat, stiskněte tlačítko „Pokračovat později“.',
      },
      {
        headline: 'Kdybyste potřebovali pomoc ',
        content: mailto => `se zodpovídáním videopohovoru, zmáčkněte tlačítko „Pomoc“ v pravém dolním rohu stránky nebo nám pošlete email na ${mailto}.`,
        customContent: link => `Obraťte se na ${link}`,
      },
    ],

    navigationBar: {
      back: 'Zpět',
      dashboard: 'Přehled',
      frontpage: 'Titulní strana',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefon ve formátu ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      yourRatingReset: 'Reset your vote',
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      averageRating: 'Průměrné hodnocení',
      reset: 'obnovení',
    },

    share: {
      share: 'Sdílet na',
      copy: 'Kopírovat odkaz',
    },

    sort: {
      sort: 'Seřadit',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Vybráno',
      change: 'Změnit',
    },

    video: {
      videoNotFound: 'Video se zpracovává nebo video nenalezeno',
      retry: 'Zkusit znova',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Nahrát nebo natočit nové video' : 'Vybrat soubor'),
      videoPlaceholder: 'Natočte svou odpověď',
      uploadPlaceholderCandidate: 'Nahrát video',
      submit: 'Odeslat odpověď',
      notAnswered: 'Ještě jste neodpověděli',
      remove: 'Smazat natočené video',
      converting: 'Video se konvertuje. Čekejte prosím...',
      uploading: 'Video se nahrává. Čekejte prosím...',
      error: {
        invalid: 'Vybraný soubor je příliš velký. Vyberte prosím jiný soubor.',
        upload: 'Video se nám nepodařilo nahrát, promiňte. Zkuste to prosím znova.',
        transcode: 'Vybraný videosoubor byl poškozený nebo neplatný, zkuste to prosím znova.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Zobrazit více',
      showLessButtonText: 'Zobrazit méně',
      infoText1:
        'Během nahrávání ponechejte kartu aktivní na popředí. Během nahrávání nepoužívejte žádné další aplikace.',
      infoText2:
        'Videa na pozadí fungují nejlépe v nejnovějších prohlížečích a na zařízení, které je relativně nové a výkonné.',
      infoText3:
        'Ujistěte se, že jiné aplikace nepoužívají váš mikrofon nebo fotoaparát.',
    },

    webcam: {
      useVideoBgButtonText: 'Použít pozadí videa',
      removeVideoBgButtonText: 'Odstranit pozadí videa',
      starting: 'Spouští se...',
      close: 'Zavřít kameru',
      remove: 'Smazat natočené video',
      record: 'Natáčet',
      stop: 'Stop',
      retake: 'Natočit video znova',
      submit: 'Odeslat odpověď',
      converting: 'Video se konvertuje. Čekejte prosím...',
      uploading: 'Video se nahrává. Čekejte prosím...',
      downloading: 'Video se stahuje. Čekejte prosím...',
      processing: 'Zpracovává se...',
      uploadInProgress: 'Video se ještě pořád přenáší, nezavírejte prohlížeč a nepřecházejte na jinou stránku.',
      uploaded: 'Video je přenesené.',
      error: {
        DevicesNotFoundError: 'Nelze používat kameru nebo mikrofon. Překontrolujte prosím, jestli jsou zapnuté.',
        NotFoundError: 'Nelze používat kameru nebo mikrofon. Překontrolujte prosím, jestli jsou zapnuté.',
        NotAllowedError: 'Nepovolili jste používání kamery nebo mikrofonu.',
        PermissionDismissedError: 'Dialog s povolením jste zavřeli. Povolte prosím používání kamery a mikrofonu.',
        PermissionDeniedError: 'Zamítli jste přístup ke kameře nebo mikrofonu.',
        NotReadableError: 'Nelze číst stream kamery nebo mikrofonu. Možný problém s hardwarem.',
        SecurityError: 'Nelze používat kameru nebo mikrofon kvůli chybě zabezpečení',
        stream: 'Došlo k chybě. Spusťte prosím prohlížeč znova. Jestli problém přetrvá, zkuste to v jiném prohlížeči.',
        download: 'Stažení videa se nezdařilo. Zkusit znova?',
        upload: 'Stažení videa se nezdařilo. Zkusit znova?',
        emptyBlob: 'Paměť vašeho prohlížeče nebo zařízení je plná a není schopná sestavit nahrávku. Načtěte stránku znova, jestli to nepomůže, spusťte prohlížeč znova.  Jestli problém přetrvá, zkuste to v jiném prohlížeči.',
        alternativeRecorder: 'Soubor můžete nahrát také kliknutím sem.',
        reconnecting: 'Připojení bylo přerušeno. Pokoušíme se o nové připojení.',
      },
    },

    videoResponse: {
      videoPlaceholder: 'Natočte svou odpověď',
      uploadPlaceholder: 'Nahrát video',
      submit: 'Odeslat odpověď',
      notAnswered: 'Ještě jste neodpověděli',
      startInterview: 'Zahájit pohovor',
    },

    smsMessages: {
      invitationMessage: title =>
        `Dobrý den! Rádi bychom vás pozvali na videopohovor ${title}! Tato pozvánka byla odeslána i na váš e-mail. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
